import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reservation',
  templateUrl: './reservation.component.html',
  styleUrls: ['./reservation.component.styl']
})
export class ReservationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
